// @i18n-ignore-file
import { useStatsigClient } from '@statsig/react-bindings'

import { HolidayMessagingConfig } from '@src/quince-components/src/atoms/eddMessageContainer/holidayMessagingTag.types'
import QuinceApiError from '@src/quince-site-common/src/domains/quince-api-error'

const HOLIDAY_MESSAGING_CONFIG_KEY = 'holiday-messaging'

/**
 * Default holiday messaging configuration used as fallback when Statsig config is unavailable
 */
const DEFAULT_HOLIDAY_MESSAGING_CONFIG: HolidayMessagingConfig = {
  tags: [
    {
      tag: 'ARRIVES_BEFORE_CHRISTMAS',
      enabled: false,
      icon: 'https://images.ctfassets.net/afruo3gr1g6h/GmTeTVOlRiV2LUtxUGdrw/eb9d29b13cfb4f536f3b3216a310143c/gift.svg',
      textColor: '#2D822B',
      message: {
        'en-us': 'Arrives before Christmas',
        'en-ca': 'Arrives before Christmas',
        'fr-ca': 'Arrive avant Noël',
      },
      clpTags: {
        textColor: '#21201F',
        backgroundColor: '#2D822B26',
        message: {
          'en-us': 'Arrives before Christmas',
          'en-ca': 'Arrives before Christmas',
          'fr-ca': 'Arrive avant Noël',
        },
      },
    },
  ],
}

/**
 * Hook to access Statsig holiday messaging dynamic configuration
 * @returns The holiday messaging configuration or null if not found/error occurs
 */
export const useStatsigDynamicHolidayConfig = (): HolidayMessagingConfig | null => {
  const { getDynamicConfig } = useStatsigClient()
  try {
    const config = getDynamicConfig(HOLIDAY_MESSAGING_CONFIG_KEY)
    // Type assertion needed because Statsig's config.value is Record<string, unknown>
    // but we know it matches HolidayMessagingConfig structure at runtime
    const configValue = config.value as unknown as HolidayMessagingConfig | null | undefined

    // Check if configValue is empty object, null, or undefined
    if (!configValue || Object.keys(configValue).length === 0) {
      return DEFAULT_HOLIDAY_MESSAGING_CONFIG
    }

    return configValue
  } catch (error) {
    // Create and throw the error to be handled by error boundaries
    throw new QuinceApiError({
      apiName: 'Get Statsig Holiday Config',
      message: 'Failed while getting statsig holiday messaging config',
      error: error as Error,
    })
  }
}
